export const PoliceDefaut = 'Barlow';
export const PoliceDefautBold = 'Barlow-bold';
